import {Injectable} from "@angular/core";

import { Observable } from 'rxjs';
import { FilterFormService } from "../filter_form/filter_form.service";
import { AuthService } from "../../auth.service";
import { DataProvider2 } from "../../provider/data2.provider";


@Injectable()
export class SiteInfoService {
	batch: any[] = [];
	
	intervalId: number = null;
	
	constructor(
		public filter: FilterFormService,
		public authService: AuthService,
		public dp: DataProvider2,
	) {
		
	}
	
	get(searchUrl): any {
		const me = this;
		
		const item = {
			searchUrl,
			sub: null
		};
		
		const ob = new Observable(sub => {
			item.sub = sub;
		});
		
		me.batch.push(item);
		
		if (me.intervalId == null) {
			me.intervalId = setInterval(() => {
				if (me.batch.length > 0) {
					const batch = me.batch.splice(0, Math.min(me.batch.length, 400));
					const domains = batch.map(v => v.searchUrl);
					const subs = batch.map(v => v.sub);
					
					me.dp.post('/site_status', {domains}).subscribe(v => {
						subs.forEach(function (sub, i) {
							const searchUrl = domains[i];
							
							const site = v['sites'].find((element) => element.searchUrl === searchUrl);
							
							sub.next(site);
							sub.complete();
						});
					});
				} else {
					clearInterval(me.intervalId);
					
					me.intervalId = null;
				}
			}, 1000);
		}
		
		return ob;
	}
}
